module.exports = __webpack_public_path__ + "img/13.c10d3a71.png";